import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";

import WPDropdown from "../../../packages/WPDropdown";

import { CHEMICAL_UNIT_DROPDOWN_OPTIONS } from "../chemicalLibrary.constants";

const ChemicalDropdownRenderer = React.memo(({ value, context, data }) => {
  const handleDropdownChange = useCallback(
    (selectedOption) => {
      const unit = selectedOption.value;
      const hasChanged = unit !== data.unit;
      if (hasChanged) {
        context.onChemicalDataChange?.({ id: data.id, unit });
      }
    },
    [context, data],
  );

  const getChemicalOptionLabel = (option) => option.label;

  const getChemicalValue = useMemo(
    () =>
      CHEMICAL_UNIT_DROPDOWN_OPTIONS.find(
        (item) => item.value.toString() === value?.toString(),
      ) || "",
    [value],
  );

  return (
    <div className="flex-ai-center">
      <WPDropdown
        id={`chemical_dropdown_${data.id}`}
        name={`chemical_dropdown_${data.id}`}
        value={getChemicalValue}
        options={CHEMICAL_UNIT_DROPDOWN_OPTIONS}
        onChange={handleDropdownChange}
        getOptionLabel={getChemicalOptionLabel}
        customClassName="chemical-unit-dropdown"
      />
    </div>
  );
});

ChemicalDropdownRenderer.displayName = "ChemicalDropdownRenderer";

ChemicalDropdownRenderer.propTypes = {
  value: PropTypes.string.isRequired,
  context: PropTypes.shape({ onChemicalDataChange: PropTypes.func }),
  data: PropTypes.object.isRequired,
};

export default ChemicalDropdownRenderer;
